import React from 'react'
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { cancelBtnSx, dialogContentSx, dialogPaperSx, dialogTitleSx } from './pushStyles'

interface Props {
    open: boolean
    onClose: () => void
    title: string
    icon?: React.ReactNode
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg'
    busy?: boolean
    children: React.ReactNode
    cancelText?: string
    confirmText?: string
    onConfirm?: () => void
    confirmDisabled?: boolean
}

/** Form dialog styled like the Referrals dialog (#242424 body, orange gradient title). */
const DarkDialog: React.FC<Props> = ({
    open, onClose, title, icon, maxWidth = 'sm', busy = false, children,
    cancelText = 'Cancel', confirmText, onConfirm, confirmDisabled,
}) => (
    <Dialog
        open={open}
        onClose={busy ? undefined : onClose}
        maxWidth={maxWidth}
        fullWidth
        slotProps={{ paper: { sx: dialogPaperSx } }}
    >
        <DialogTitle sx={dialogTitleSx}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                {icon && (
                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {icon}
                    </Box>
                )}
                {title}
            </Box>
            <IconButton onClick={onClose} size="small" disabled={busy}>
                <CloseIcon sx={{ color: '#fff', fontSize: 18 }} />
            </IconButton>
        </DialogTitle>
        <DialogContent sx={dialogContentSx}>{children}</DialogContent>
        <Box sx={{ px: 3, pb: 3, pt: 1, display: 'flex', gap: 1.5, backgroundColor: '#242424' }}>
            <Button fullWidth variant="outlined" onClick={onClose} disabled={busy} sx={cancelBtnSx}>
                {cancelText}
            </Button>
            {onConfirm && (
                <Button
                    fullWidth
                    variant="contained"
                    onClick={onConfirm}
                    disabled={busy || confirmDisabled}
                    sx={{
                        background: 'linear-gradient(135deg, #f2674a, #d94f35)', borderRadius: '10px', fontWeight: 700,
                        textTransform: 'none', boxShadow: '0 4px 16px rgba(242,103,74,.4)',
                        '&:hover': { filter: 'brightness(0.92)' }, '&.Mui-disabled': { opacity: 0.45, color: '#fff' },
                    }}
                >
                    {busy ? <CircularProgress size={16} sx={{ color: '#fff' }} /> : confirmText}
                </Button>
            )}
        </Box>
    </Dialog>
)

export default DarkDialog
